export enum GoalStatus {
    Active = "active",
    Completed = "completed",
    Archived = "archived",
}

export enum GoalType {
    Development = "development",
    Performance = "performance",
}

export interface GoalConnection {
    id: string;
    name: string | null;
    job_title: string | null;
}

export interface GoalAction {
    id: string;
    goal_id: string;
    title: string;
    description: string;
    status: GoalStatus;
    source: string;
    completed_at: string | null;
    created_at: string;
    updated_at: string;
}

export interface Goal {
    id: string;
    connection_id: string | null;
    connection: GoalConnection | null;
    title: string;
    description: string;
    status: GoalStatus;
    source: string;
    goal_type: GoalType;
    team_member_goal: boolean;
    prioritized_at: string | null;
    completed_at: string | null;
    created_at: string;
    updated_at: string;
    actions: GoalAction[];
    reference_session_created_at: string | null;
}

export interface GoalCreateRequest {
    title: string;
    description?: string;
    goal_type?: GoalType;
    team_member_goal?: boolean;
    is_prioritized?: boolean;
    connection_id?: string | null;
}

export interface GoalUpdateRequest {
    title?: string;
    description?: string;
    status?: GoalStatus;
    goal_type?: GoalType;
    team_member_goal?: boolean;
    is_prioritized?: boolean;
    connection_id?: string | null;
    confirm_goal?: boolean;
}

export interface GoalActionCreateRequest {
    title: string;
    description?: string;
}

export interface GoalActionUpdateRequest {
    title?: string;
    description?: string;
    status?: GoalStatus;
    confirm_action?: boolean;
}

export interface GoalCreateEditData {
    id?: string;
    title: string;
    description: string;
    goal_type: GoalType;
    team_member_goal: boolean;
    is_prioritized?: boolean;
    connection_id?: string | null;
    connection?: GoalConnection | null;
}

export interface GoalFeedbackRequest {
    value: number;
    issues?: string[];
    comment?: string | null;
    goal_action_id?: string | null;
}

export interface GoalFeedbackRead {
    id: string;
    goal_id: string;
    user_id: string;
    goal_action_id: string | null;
    value: number;
    issues: string[];
    comment: string | null;
    created_at: string;
    updated_at: string;
}

export interface GoalListResponse {
    goals: Goal[];
    has_more_goals: boolean;
    cursor: string | null;
}
